// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"dd4c9398","782":"2dd490d2"}[chunkId] + ".chunk.css";
};